import { FC, PropsWithChildren, useImperativeHandle, useState } from 'react'
import { Swiper, SwiperProps } from 'swiper/react'
import { Pagination, Navigation } from 'swiper'
import 'swiper/css'

import { Swiper as SwiperClass } from 'swiper/types'
import React from 'react'

interface PdDisplaySwiperPanelProps {
  children?: any
  elClassName?: {
    elClassName?: string
    nextElClassName?: string
    prevElClassName?: string
    paginationClassName?: string
  }
  onRef?: React.MutableRefObject<{ onChangeSlide: (index: number) => void } | undefined>
}

const PdDisplaySwiperPanel: FC<PropsWithChildren<PdDisplaySwiperPanelProps & SwiperProps>> = (props) => {
  const [swiperInstance, setSwiperInstance] = useState<SwiperClass | null>(null)

  function onSwiperInit(swiper: SwiperClass) {
    setSwiperInstance(swiper)
  }
  function onChangeSlide(realIndex: number) {
    swiperInstance && swiperInstance?.slideToLoop(realIndex)
  }
  useImperativeHandle(props.onRef, () => {
    return {
      onChangeSlide: onChangeSlide,
    }
  })
  return (
    <div className={['pd-display-swiper-panel', 'w-full laptop:mx-auto relative'].join(' ')}>
      <Swiper
        onInit={onSwiperInit}
        modules={[Pagination, Navigation]}
        scrollbar={{ draggable: true }}
        onSwiper={(swiper) => console.log(swiper)}
        onSlideChange={() => console.log('slide change')}
        {...props}
      >
        {props?.children}
      </Swiper>
      <div className={[props?.elClassName?.elClassName].join(' ')}>
        <div className={[props?.elClassName?.paginationClassName].join(' ')}></div>
        <div
          className={props?.elClassName?.nextElClassName}
          onClick={() => {
            swiperInstance?.slideNext()
          }}
        ></div>
        <div
          className={props?.elClassName?.prevElClassName}
          onClick={() => {
            swiperInstance?.slidePrev()
          }}
        ></div>
      </div>
    </div>
  )
}
export default PdDisplaySwiperPanel
